var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from '../../store/connect';
import { useTranslation } from "react-i18next";
import querystring from "querystring";
import styled from "styled-components";
import pick from "lodash/pick";
import get from "lodash/get";
import { setAppState } from "../../store/actions";
import { getBankTransferData, getBankTransferEntities } from "../../store/actions/response.actions";
import { APP_STATE } from "../../store/store";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { getPaymentManager } from "../../models/PaymentModel/PaymentModelManager";
import { Flex } from "../Flex";
import { BANK_TRANSFER_DETAILS, BANK_TRANSFER_BANK, BANK_TRANSFER_LABEL, BANK_TRANSFER_VALUE, MESSAGE_HEADER } from "../../classConstants";
import { currency } from "../../helpers";
import parse from "html-react-parser";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { Loader } from "../Loader/Loader";
import { Messages } from "../OutgoingMessagesPage/Messages";
import { getBookManager } from "../../models/BookModel";
import { Message } from "../OutgoingMessagesPage/Message";
var bankTransferFactory = function () {
    var BankTransferPage = function (props) {
        var t = useTranslation().t;
        var search = useLocation().search;
        var queryObject = pick(querystring.parse(search.substr(1)), "payment_session_id", "book_success_id");
        var setAppState = props.setAppState, bankTransferDetails = props.bankTransferDetails, getBankTransferEntities = props.getBankTransferEntities, banks = props.banks;
        var fields = ["bank_name", "owner", "iban", "bic", "billAmount", "payment_purpose"];
        var paymentPurpose = (bankTransferDetails === null || bankTransferDetails === void 0 ? void 0 : bankTransferDetails.printed_payment_purpose) || "";
        useEffect(function () {
            setAppState(APP_STATE.BANK_TRANSFER);
            getBankTransferEntities(queryObject);
        }, []);
        var amount = currency(bankTransferDetails === null || bankTransferDetails === void 0 ? void 0 : bankTransferDetails.total).format();
        var Row = function (_a) {
            var label = _a.label, value = _a.value;
            return (React.createElement(Flex, { isInline: true },
                React.createElement("strong", { className: BANK_TRANSFER_LABEL }, label),
                React.createElement("span", { className: BANK_TRANSFER_VALUE }, parse(value))));
        };
        var getRows = function (bank) {
            return fields.map(function (field, i) {
                var value = "";
                switch (field) {
                    case "billAmount":
                        value = amount;
                        break;
                    case "payment_purpose": {
                        value = t("bank_transfer.payment_purpose_value", {
                            paymentPurpose: paymentPurpose,
                        });
                        break;
                    }
                    default:
                        value = get(bank, field);
                }
                return React.createElement(Row, { key: i, label: t("bank_transfer." + field), value: value });
            });
        };
        var Rows = function () {
            return banks.map(function (bank, i) {
                return React.createElement(Bank, { key: i, className: BANK_TRANSFER_BANK },
                    " ",
                    getRows(bank),
                    " ");
            });
        };
        var getIntro = function () {
            return parse(t("bank_transfer.intro", {
                amount: amount,
                paymentPurpose: paymentPurpose,
            }));
        };
        if (props.hasEndUserError)
            return null;
        if (props.hasErrored)
            return null;
        if (props.isLoading)
            return React.createElement(Loader, null);
        return (React.createElement(BankTransferMessages, { messages: props.messages },
            React.createElement(BankTransferDetailsMessage, { className: BANK_TRANSFER_DETAILS, index: -1, title: t("bank_transfer.title") },
                React.createElement("p", null, getIntro()),
                React.createElement(Rows, null))));
    };
    var mergeStateToProps = function (state) {
        var _a = getBankTransferData(state.responseReducer).response, response = _a === void 0 ? null : _a;
        return {
            response: response,
            loaderState: state.loaderReducer
        };
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var loaderState = new LoaderState(stateProps.loaderState, { keys: [API_METHODS_ENUM.GET_BANK_TRANSFER_ENTITIES] });
        var mergeProps = __assign(__assign(__assign({}, dispatchProps), ownProps), { banks: [], messages: [], bankTransferDetails: {}, hasEndUserError: false, hasErrored: loaderState.hasErrored(), isLoading: !loaderState.hasLoaded() || loaderState.isLoading() });
        if (stateProps.response) {
            var rm = getResponseManager(stateProps.response);
            mergeProps.hasEndUserError = rm.name === "end_user_error";
            if (mergeProps.hasEndUserError)
                return mergeProps;
            var bankTransferDetails = rm.bankTransferDetails() || {};
            var entities = rm.entities();
            var messageEntities = rm.outgoingMessages();
            if (!entities)
                return mergeProps;
            var bm = getBookManager(messageEntities);
            var pm = getPaymentManager(entities);
            mergeProps.messages = bm.outgoingMessages().all();
            mergeProps.bankTransferDetails = bankTransferDetails;
            mergeProps.banks = pm.banks().all().map(function (m) { return pick(m, "owner", "bank_name", "iban", "blz", "bic"); });
        }
        return mergeProps;
    };
    return connect(mergeStateToProps, { setAppState: setAppState, getBankTransferEntities: getBankTransferEntities }, mergeProps)(BankTransferPage);
};
export var BankTransferPage = bankTransferFactory();
var BankTransferMessages = styled(Messages)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 1em;\n"], ["\n    margin-top: 1em;\n"])));
var BankTransferDetailsMessage = styled(Message)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .", " {\n        --ws-message-header-bg: var(--ws-primary-color);\n        --ws-message-header-text: var(--ws-primary-color-contrast);\n    }\n"], ["\n    .", " {\n        --ws-message-header-bg: var(--ws-primary-color);\n        --ws-message-header-text: var(--ws-primary-color-contrast);\n    }\n"])), MESSAGE_HEADER);
var Bank = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:not(:last-child) {\n        margin-bottom: 1rem;\n    }\n    .", " {\n        max-width: 20ch;\n        max-width: clamp(100px, 20ch, 100%);\n        flex: 1 0;\n    }\n    .", " {\n        padding-left: 15px;\n        flex: 2 0;\n    }\n"], ["\n    &:not(:last-child) {\n        margin-bottom: 1rem;\n    }\n    .", " {\n        max-width: 20ch;\n        max-width: clamp(100px, 20ch, 100%);\n        flex: 1 0;\n    }\n    .", " {\n        padding-left: 15px;\n        flex: 2 0;\n    }\n"])), BANK_TRANSFER_LABEL, BANK_TRANSFER_VALUE);
var templateObject_1, templateObject_2, templateObject_3;
